/**
 * Dark Mode Toggle
 * ================
 * Toggles between light/dark themes.
 * Persists preference in localStorage.
 * Respects system preference as default.
 *
 * The initial theme is set inline in default.hbs <head> to avoid FOUC.
 * This module handles the toggle button interaction.
 */

export default function darkMode() {
    const toggle = document.querySelector('.gh-dark-toggle');
    if (!toggle) return;

    const html = document.documentElement;

    function getTheme() {
        return html.getAttribute('data-theme');
    }

    function setTheme(theme) {
        html.setAttribute('data-theme', theme);
        localStorage.setItem('theme', theme);
    }

    toggle.addEventListener('click', () => {
        const current = getTheme();
        const next = current === 'dark' ? 'light' : 'dark';
        setTheme(next);
    });

    // Listen for system preference changes (if no explicit user choice)
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
        // Only auto-switch if user hasn't explicitly chosen
        const stored = localStorage.getItem('theme');
        if (!stored) {
            setTheme(e.matches ? 'dark' : 'light');
        }
    });
}
